var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatmain"},[_c('div',{staticClass:"sidebar"},[_c('list')],1),_c('div',{staticClass:"main"},[_c('ContactInfo',{staticClass:"contactinfo"}),_c('message'),_c('MessageText',{staticClass:"text"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }